import PopupFeature from 'ol-ext/overlay/PopupFeature';
import Select from 'ol/interaction/Select';
import { singleClick } from 'ol/events/condition';


var list=['lasy','bagna','rzeki','akweny','drogi','powiaty','ziemie','wojewodztwa','parafie','dekanaty','archidiakonaty','diecezje','vector']

// Select  interaction
export var selectfeature = new Select({
    hitTolerance: 5,
    multi: true,
    condition: singleClick,
    style:null,
    layers: function(layer) {

        if(layer.getProperties().layerName=='miejscowosci'||layer.getProperties().layerName=='miejscowoscicapital' || layer.getProperties().layerName.includes('_'))
             return true;
    },
  });

  
export var selectallfeatures = new Select({
    hitTolerance: 5,
    multi: true,
    condition: singleClick,
    style:null,
    layers: function(layer) {
        if(layer.getProperties().layerName=='miejscowosci'||layer.getProperties().layerName=='miejscowoscicapital' || layer.getProperties().layerName.includes('_'))
         return true;
    },
  });

  export var selectBoundaries = new Select({
    hitTolerance: 5,
    multi: true,
    condition: singleClick,
    style:null,
    layers: function(layer) {
        if(layer.getProperties().layerName=='diecezje' || layer.getProperties().layerName=='archidiakonaty' || layer.getProperties().layerName=='dekanaty' || layer.getProperties().layerName=='parafie' || layer.getProperties().layerName=='wojewodztwa' || layer.getProperties().layerName=='ziemie'|| layer.getProperties().layerName=='powiaty')
        return true;
    },
  });


// Select places control
export var popup = new PopupFeature({
    popupClass: 'default anim',
    select: selectfeature,
    canFix: false,
    maxChar:500,
    template: {
        title: 
          // 'nom',   // only display the name
          function(f) {
            if (f.get('rok')!=null)
            return f.get('nazwa_16w')+' ('+f.get('rok')+')'
            else return f.get('nazwa_16w')+ ' [Miejscowości AHP]'
          },
        attributes: { 
            'id_osady': { 
                title: 'Identyfikator',
                visible: function(f,val) {
                  if(f.get('id_osady')=='' | f.get('id_osady')==null) return false
                  else return true
                } 
            },
            'nazwa_16w': { 
                title: 'Nazwa szesnastowieczna',
                visible: function(f,val) {
                  if(f.get('nazwa_16w')=='' | f.get('nazwa_16w')==null) return false
                  else return true
                } 
            },
            'rok': { 
                title: 'Rok',
                visible: function(f,val) {
                    if(f.get('rok')=='' | f.get('rok')==null) return false
                    else return true
                } 
            },
            'data': { 
                title: 'Data',
                visible: function(f,val) {
                    if(f.get('data')=='' | f.get('data')==null) return false
                    else return true
                } 
            },
            'data_zrd': { 
                title: 'Data – forma źródłowa',
                visible: function(f,val) {
                    if(f.get('data_zrd')=='' | f.get('data_zrd')==null) return false
                    else return true
                } 
            },
            'sygn': { 
                title: 'Sygnatura',
                visible: function(f,val) {
                    if(f.get('sygn')=='' |f.get('sygn')==null) return false
                    else return true
                }
            },
            'str': { 
                title: 'Strona',
                visible: function(f,val) {
                    if(f.get('str')=='' | f.get('str')==null) return false
                    else return true
                }
            },
            'link_do_skanu': { 
                title: 'Źródło',
                format: function(val,f) { 
                    return '<a href=' + f.get('link_do_skanu') + ' target="_blank">Link do skanu</a>'
                },
                visible: function(f,val) {
                    if(f.get('link_do_skanu')=='' | f.get('link_do_skanu')==null) return false
                    else return true
                }
            },
            'nr_not': { 
                title: 'Numer zapiski',
                visible: function(f,val) {
                    if(f.get('nr_not')=='' | f.get('nr_not')==null) return false
                    else return true
                }
            },
            'parafia': { 
                title: 'Parafia',
                visible: function(f,val) {
                    if(f.get('parafia')=='' |f.get('parafia')==null) return false
                    else return true
                }
            },
            'varia': { 
                title: 'Varia',
                visible: function(f,val) {
                    if(f.get('varia')=='' | f.get('varia')==null) return false
                    else return true
                }
            },
            'char_osady': { 
                title: 'Źródłowy charakter osady',
                visible: function(f,val) {
                    if(f.get('char_osady')=='' | f.get('char_osady')==null) return false
                    else return true
                }
            },
            'nazw_zrd': { 
                title: 'Nazwa źródłowa',
                visible: function(f,val) {
                    if(f.get('nazw_zrd')=='' | f.get('nazw_zrd')==null) return false
                    else return true
                } 
            },
            'wlasciciel': { 
                title: 'Właściciel forma źródłowa',
                visible: function(f,val) {
                    if(f.get('wlasciciel')=='' | f.get('wlasciciel')==null) return false
                    else return true
                } 
            },
            'osoby': { 
                title: 'Osoby',
                visible: function(f,val) {
                    if(f.get('osoby')=='' | f.get('osoby')==null) return false
                    else return true
                } 
            },
            'rodziny': { 
                title: 'Rodziny',
                visible: function(f,val) {
                    if(f.get('rodziny')=='' | f.get('rodziny')==null) return false
                    else return true
                } 
            },
            'obiekty': { 
                title: 'Obiekty',
                visible: function(f,val) {
                    if(f.get('obiekty')=='' | f.get('obiekty')==null) return false
                    else return true
                } 
            },
            'wyszynk_gr': { 
                title: 'Wyszynk – grosze',
                visible: function(f,val) {
                    if(f.get('wyszynk_gr')=='' |f.get('wyszynk_gr')==null) return false
                    else return true
                } 
            },
            'wyszynk_opis': { 
                title: 'Wyszynk – opis',
                visible: function(f,val) {
                    if(f.get('wyszynk_opis')=='' | f.get('wyszynk_opis')==null) return false
                    else return true
                } 
            },
            'taberna': { 
                title: 'Karczma',
                visible: function(f,val) {
                    if(f.get('taberna')=='' | f.get('taberna')==null) return false
                    else return true
                } 
            },
            'tbr_hrd': { 
                title: 'Karczma dziedziczna',
                visible: function(f,val) {
                    if(f.get('tbr_hrd')=='' |f.get('tbr_hrd')==null) return false
                    else return true
                } 
            },
            'tbr_man': { 
                title: 'Karczma doroczna',
                visible: function(f,val) {
                    if(f.get('tbr_man')==null | f.get('tbr_man')=='' ) return false
                    else return true
                } 
            },
            'k_walne': { 
                title: 'Koło walne',
                visible: function(f,val) {
                    if(f.get('k_walne')==null | f.get('k_walne')=='' ) return false
                    else return true
                } 
            },
            'k_korz': { 
                title: 'Koło korzeczne',
                visible: function(f,val) {
                    if(f.get('k_korz')=='' | f.get('k_korz')==null) return false
                    else return true
                } 
            },
            'rota_hrdz': { 
                title: 'Koło dziedziczne',
                visible: function(f,val) {
                    if(f.get('rota_hrd')=='' | f.get('rota_hrd')==null) return false
                    else return true
                } 
            },
            'rota_ann': { 
                title: 'Koło doroczne',
                visible: function(f,val) {
                    if(f.get('rota_ann')==null | f.get('rota_ann')=='' ) return false
                    else return true
                } 
            },
            'wiatrak': { 
                title: 'Wiatrak',
                visible: function(f,val) {
                    if(f.get('wiatrak')=='' | f.get('wiatrak')==null) return false
                    else return true
                } 
            },
            'wtr_hrd': { 
                title: 'Wiatrak dziedziczny',
                visible: function(f,val) {
                    if(f.get('wtr_hrd')=='' | f.get('wtr_hrd')==null) return false
                    else return true
                } 
            },
            'wtr_ann': { 
                title: 'Wiatrak doroczny',
                visible: function(f,val) {
                    if(f.get('wtr_ann')=='' | f.get('wtr_ann')==null) return false
                    else return true
                } 
            },
            'k_inne_lb': { 
                title: 'Liczba innych kół',
                visible: function(f,val) {
                    if(f.get('k_inne_lb')=='' | f.get('k_inne_lb')==null) return false
                    else return true
                } 
            },
            'k_inne_kom': { 
                title: 'Rodzaj innych kół',
                visible: function(f,val) {
                    if(f.get('k_inne_kom')=='' | f.get('k_inne_kom')==null) return false
                    else return true
                } 
            },
            'garnce_gorz': { 
                title: 'Garnce gorzałczane',
                visible: function(f,val) {
                    if(f.get('garnce_gorz')=='' | f.get('garnce_gorz')==null) return false
                    else return true
                } 
            },
            'lany_kmc': { 
                title: 'Łany kmiece',
                visible: function(f,val) {
                    if(f.get('lany_kmc')=='' | f.get('lany_kmc')==null) return false
                    else return true
                } 
            },
            'lany_pust': { 
                title: 'Łany puste',
                visible: function(f,val) {
                    if(f.get('lany_pust')=='' | f.get('lany_pust')==null) return false
                    else return true
                } 
            },
            'aratura_sua': { 
                title: 'Łany szlachty zagrodowej',
                visible: function(f,val) {
                    if(f.get('aratura_sua')=='' | f.get('aratura_sua')==null) return false
                    else return true
                } 
            },
            'lany_solt': { 
                title: 'Łany sołtysie',
                visible: function(f,val) {
                    if(f.get('lany_solt')=='' | f.get('lany_solt')==null) return false
                    else return true
                } 
            },
            'inne_lany_lb': { 
                title: 'Liczba innych łanów',
                visible: function(f,val) {
                    if(f.get('inne_lany_lb')=='' | f.get('inne_lany_lb')==null) return false
                    else return true
                } 
            },
            'inne_lany_kom': { 
                title: 'Rodzaj innych łanów',
                visible: function(f,val) {
                    if(f.get('inne_lany_kom')=='' | f.get('inne_lany_kom')==null) return false
                    else return true
                } 
            },
            'lany_suma': { 
                title: 'Suma łanów',
                visible: function(f,val) {
                    if(f.get('lany_suma')=='' | f.get('lany_suma')==null) return false
                    else return true
                } 
            },
            'owce': { 
                title: 'Owce',
                visible: function(f,val) {
                    if(f.get('owce')=='' | f.get('owce')==null) return false
                    else return true
                } 
            },
            'rybacy': { 
                title: 'Rybacy',
                visible: function(f,val) {
                    if(f.get('rybacy')=='' | f.get('rybacy')==null) return false
                    else return true
                } 
            },
            'rzem_lb': { 
                title: 'Liczba rzemieślników',
                visible: function(f,val) {
                    if(f.get('rzem_lb')=='' | f.get('rzem_lb')==null) return false
                    else return true
                } 
            },
            'rzem_lista': { 
                title: 'Lista zawodów',
                visible: function(f,val) {
                    if(f.get('rzem_lista')=='' | f.get('rzem_lista')==null) return false
                    else return true
                } 
            },
            'czeladnicy': { 
                title: 'Czeladnicy',
                visible: function(f,val) {
                    if(f.get('czeladnicy')=='' | f.get('czeladnicy')==null) return false
                    else return true
                } 
            },
            'zagr_niesprec': { 
                title: 'Zagrodnicy niesprecyzowani',
                visible: function(f,val) {
                    if(f.get('zagr_niesprec')=='' | f.get('zagr_niesprec')==null) return false
                    else return true
                } 
            },
            'zagr_ziem': { 
                title: 'Zagrodnicy z ziemią',
                visible: function(f,val) {
                    if(f.get('zagr_ziem')=='' | f.get('zagr_ziem')==null) return false
                    else return true
                } 
            },
            'zagr_bez': { 
                title: 'Zagrodnicy bez ziemi',
                visible: function(f,val) {
                    if(f.get('zagr_bez')=='' | f.get('zagr_bez')==null) return false
                    else return true
                } 
            },
            'zagr_dom': { 
                title: 'Zagrodnicy z domem',
                visible: function(f,val) {
                    if(f.get('zagr_dom')=='' | f.get('zagr_dom')==null) return false
                    else return true
                } 
            },
            'kom_niesprec': { 
                title: 'Komornicy niesprecyzowani i miejscy',
                visible: function(f,val) {
                    if(f.get('kom_niesprec')=='' | f.get('kom_niesprec')==null) return false
                    else return true
                } 
            },
            'kom_dob': { 
                title: 'Komornicy z dobytkiem',
                visible: function(f,val) {
                    if(f.get('kom_dob')=='' | f.get('kom_dob')==null) return false
                    else return true
                } 
            },
            'kom_bez': { 
                title: 'Komornicy bez dobytku',
                visible: function(f,val) {
                    if(f.get('kom_bez')=='' | f.get('kom_bez')==null) return false
                    else return true
                } 
            },
            'rataje': { 
                title: 'Rataje',
                visible: function(f,val) {
                    if(f.get('rataje')=='' | f.get('rataje')==null ) return false
                    else return true
                } 
            },
            'luzni': { 
                title: 'Ludzie luźni',
                visible: function(f,val) {
                    if(f.get('luzni')=='' | f.get('luzni')==null) return false
                    else return true
                } 
            },
            'Zydzi_gr': { 
                title: 'Żydzi – grosze',
                visible: function(f,val) {
                    if(f.get('Zydzi_gr')=='' | f.get('Zydzi_gr')==null) return false
                    else return true
                } 
            },
            'szos_fl': { 
                title: 'Szos – floreny',
                visible: function(f,val) {
                    if(f.get('szos_fl')=='' | f.get('szos_fl')==null) return false
                    else return true
                } 
            },
            'szos_gr': { 
                title: 'Szos – grosze',
                visible: function(f,val) {
                    if(f.get('szos_gr')=='' | f.get('szos_gr')==null) return false
                    else return true
                } 
            },
            'szos_w_gr': { 
                title: 'Szos w groszach',
                visible: function(f,val) {
                    if(f.get('szos_w_gr')=='' | f.get('szos_w_gr')==null) return false
                    else return true
                } 
            },
            'suma_fl': {
                title: 'Podatek: floreny',
                visible: function(f,val) {
                    if(f.get('suma_fl')==null | f.get('suma_fl')=='' ) return false
                    else return true
                } 
            },
            'suma_gr': {
                title: 'Suma – grosze',
                visible: function(f,val) {
                    if(f.get('suma_gr')==null | f.get('suma_gr')=='' ) return false
                    else return true
                } 
            },
            'suma_den': { 
                title: 'Suma – denary',
                visible: function(f,val) {
                    if(f.get('suma_den')==null | f.get('suma_den')=='' ) return false
                    else return true
                } 
            },
            'suma_w_gr': { 
                title: 'Suma w groszach',
                visible: function(f,val) {
                    if(f.get('suma_w_gr')=='' | f.get('suma_w_gr')==null) return false
                    else return true
                } 
            },
            'kmc_liczba': { 
                title: 'Liczba kmieci',
                visible: function(f,val) {
                    if(f.get('kmc_liczba')=='' | f.get('kmc_liczba')==null) return false
                    else return true
                } 
            },
            'pop_ruski': { 
                title: 'Pop ruski',
                visible: function(f,val) {
                    if(f.get('pop_ruski')=='' | f.get('pop_ruski')==null) return false
                    else return true
                } 
            },
            'pop_podatek': { 
                title: 'Podatek od popa',
                visible: function(f,val) {
                    if(f.get('pop_podatek')=='' | f.get('pop_podatek')==null) return false
                    else return true
                } 
            },
            'konie': { 
                title: 'Konie',
                visible: function(f,val) {
                    if(f.get('konie')=='' | f.get('konie')==null) return false
                    else return true
                } 
            },
            'nazwa_odmianki': {
                title: 'Odmianki',
                format: function(val,f) { 
                    if(f.get('nazwa_odmianki')!=null)
                    return f.get('nazwa_odmianki')
                    else return ''
                },
                visible: function(f,val) {
                    if(f.get('nazwa_odmianki')==null | f.get('nazwa_odmianki')=='') return false
                    else return true
                }
            },
            'nazwa_wspolczesna': {
                title: 'Nazwa współczesna',
                format: function(val,f) { 
                    if(f.get('nazwa_wspolczesna')!=null)
                    return f.get('nazwa_wspolczesna')
                    else return ''
                },
                visible: function(f,val) {
                    if(f.get('nazwa_wspolczesna')==null | f.get('nazwa_wspolczesna')=='') return false
                    else return true
                }
            },
            'charakter_osady': {
                title: 'Charakter osady'
            },
            'rodzaj_wlasnosci': {
                title: 'Rodzaj własności',
                format: function(val,f) {
                    switch (f.get('rodzaj_wlasnosci')) {
                        case 'd':
                          return 'duchowna';
                        case 'dm':
                          return 'duchowna, miejska';
                        case 'ds':
                            return 'duchowna, szlachecka';
                        case 'dsm':
                            return 'duchowna, szlachecka, miejska';
                        case 'k':
                          return 'królewska';
                        case 'kd':
                          return 'królewska, duchowna';
                        case 'kdm':
                            return 'królewska, duchowna, miejska';
                        case 'ks':
                          return 'królewska, szlachecka';
                        case 'km':
                          return 'królewska, miejska';
                        case 'm':
                            return 'miejska';
                        case 's':
                          return 'szlachecka';
                        case 'sm':
                          return 'szlachecka, miejska';
                        default:
                            return null;
                      } 
                }
            },
            'powiat_p': {
                title: 'Powiat'
            },
            'woj_p': {
                title: 'Województwo'
            },
            'wikihum': {
                title: 'Identyfikator WikiHum'
            },
          
        }
    }
  });